import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import { environment } from "pstat-anywhere/relay";

const mutation = graphql`
  mutation AcceptSystemDocumentTemplateMutation(
    $input: AcceptSystemDocumentTemplateInput!
  ) {
    acceptSystemDocumentTemplate(input: $input) {
      ok
      redirectPath
      error
    }
  }
`;

function acceptTemplate(templatePk, callback) {
  const variables = {
    input: {
      systemDocumentTemplate: templatePk
    }
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => callback(response, errors),
    onError: error => {
      throw new Error(error);
    }
  });
}

export default acceptTemplate;
